<!-- 測定結果レポート本体(OF-5チェック結果あり) -->
<template>
  <!-- タイトル -->
  <div class="report-title">
    <div class="report-title-detail">
      <div class="report-title-detail-left"></div>
      <div v-if="!isAnalysisFlag" class="report-title-detail-right flex justify-content-center" style="margin-left: auto;">
        <div class="">{{ $t('report.count_per_second_short') }}</div>
        <div class="ml-8 report-face report-face--good"></div>
        <div class="ml-4">{{ $t('report.threshold_6_or_more') }}</div>
        <div class="ml-8 report-face report-face--sort-good"></div>
        <div class="ml-4">{{ $t('report.threshold_4_to_5') }}</div>
        <div class="ml-8 report-face report-face--bad"></div>
        <div class="ml-4">{{ $t('report.threshold_less_than_4') }}</div>
      </div>
      <div v-else class="report-title-detail-right">{{ $t('report.with_clarity_note') }}</div>
    </div>
  </div>

  <!-- グラフ -->
  <div class="report-graph" :class="!isAnalysisFlag?' mt-16':'mt-29'">
    <div  v-for="measure in measurements" :key="measure.type">
      <div class="report-graph-column"
      :class="[`report-graph-column--${vocabCounts[measure.type] == null ? 'none' : measure.type}`,
      isAnalysisFlag?'report-graph-column--analaysis':'']">
        <template v-if="!isAnalysisFlag">
          <div class="report-graph-column-audio"
          :class="vocabCounts[measure.type] == null?`report-graph-column-audio--${measure.type}`:''">
            <div class="audio-icon" :class="vocabCounts[measure.type] == null?`audio-icon--${measure.type}`:''"></div>
            <div class="audio-text">{{ $t('report.pronunciation_count') }}</div>
          </div>
        </template>
        <template v-else>
          <div class="report-graph-column-audio report-graph-column-audio--analaysis"
          :class="vocabCounts[measure.type] == null?`report-graph-column-audio--${measure.type}`:''">
            <div class="audio-icon audo-icon--analaysis" :class="vocabCounts[measure.type] == null?`audio-icon--${measure.type}`:''"></div>
            <div class="audio-text audio-text--analaysis">{{ $t('report.count_and_clarity') }}</div>
          </div>
        </template>

        <template v-if="!isAnalysisFlag">
          <div class="report-graph-column-top">
            <div class="top-title mt-4">{{ $t('report.performance') }}</div>
            <div class="top-status">
              <div class="top-status-colum">
                <template v-if="vocabCounts[measure.type] == null">
                  <div class="top-status-star-colum top-status-star-colum--none"></div>
                  <div class="top-status-none-colum">{{ $t('test_list.status_not_tested') }}</div>
                </template>
                <template v-if="vocabCounts[measure.type] != null">
                  <div class="top-status-star-colum"
                  :class="[`top-status-star-colum--${vocabPerSeconds[measure.type] >= 6.0?'good':vocabPerSeconds[measure.type] >= 4.0?'sortgood':'bad'}-${measure.type}`]"></div>
                  <div class="top-status-face-colum">
                    <div class="face"
                    :class="[`${vocabPerSeconds[measure.type] >= 6.0?'good':vocabPerSeconds[measure.type] >= 4.0?'sortgood':'bad'}-face--${measure.type}`]"></div>
                    <div>{{vocabPerSeconds[measure.type] >= 6.0?$t('report.feedback_excellent'):vocabPerSeconds[measure.type] >= 4.0?$t('report.feedback_almost_there'):$t('report.feedback_keep_trying')}}</div>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="report-graph-analaysis-top"  :class="[`report-graph-analaysis-top--${vocabCounts[measure.type] == null ? 'none' : measure.type}`]">
            <div class="top-column top-column--left">
              <div class="top-column-text">{{ $t('report.total_count') }}</div>
              <div class="top-column-score" :class="vocabCounts[measure.type] != null ? 'top-column-score--on':'-'">
                <span class="top-column-score-big">{{vocabCounts[measure.type] != null ? vocabCounts[measure.type]:'-'}}</span>
                <span v-show="vocabCounts[measure.type] != null">{{ $t('test_list.times') }}</span>
              </div>
            </div>
            <div class="top-column top-column--right">
              <div class="top-column-text">{{ $t('report.clear_count_prefix') }}{{measure.type == 'pa'?$t('test_list.patk_label_pa'):measure.type == 'ta'?$t('test_list.patk_label_ta'):$t('test_list.patk_label_ka')}}<span v-html="$t('report.clear_count_suffix')"></span></div>
              <div class="top-column-score" :class="analysisVocabCounts[measure.type] != null ?  'top-column-score--on':''">
                <span class="top-column-score-big">{{analysisVocabCounts[measure.type] != null ? analysisVocabCounts[measure.type]:'-'}}</span>
                <span v-show="analysisVocabCounts[measure.type] != null">{{ $t('test_list.times') }}</span>
              </div>
            </div>
            <div class="pie-charts">
              <div class="pie-charts-colum">
                <div v-if="vocabCounts[measure.type] != null" class="buttom" :style="buttom(measure.type)"></div>
                <div v-else class="buttom" :style="buttom()"></div>
                <div v-if="vocabCounts[measure.type] != null" class="center" :style="center(measure.type)"></div>
                <div v-else class="center" :style="center()"></div>
                <div v-if="vocabCounts[measure.type] != null" class="top">
                  <div class="top-text">{{analysisVocabCounts[measure.type]  != null ? graphPercent[measure.type]:'-'}}</div>
                  <div class="buttom-text">%</div>
                </div>
              </div>
            </div>
          </div>
        </template>

        <div class="report-graph-column-main">
          <div class="top-wrap">
            <div class="top-wrap-left">
              <div class="title">{{ $t('report.count_per_second') }}</div>
              <canvas
                :ref="`graphCanvas-${measure.type}`"
                :id="`graphCanvas-${measure.type}`"
                style="width: 157px; height: 106px;"
                class="graph"
                :class="(measure.measurementType == '1' || (!measure.measurementType && measurementType == '1')) ? 'graph--five' : ''">
              </canvas>
            </div>
            <div class="bottom-wrap-right" :class="[`bottom-wrap-right--${measure.type}`]">
              <div class="title" :class="!isAnalysisFlag?' mt-13':'mt-18'">{{ $t('report.per_second') }}</div>

              <div v-if="vocabCounts[measure.type] == null" class="per per--none">-</div>
              <div v-else class="per" :class="!isAnalysisFlag?'per--seconds-normal':'per--seconds-analaysis'">
                {{ $t('report.average_times_per_sec_prefix') }}<span :class="!isAnalysisFlag?'per-seconds-big':'per-seconds-analaysis'">{{ vocabPerSeconds[measure.type] }}</span>{{ $t('report.average_times_per_sec_suffix') }}
              </div>

              <template v-if="!isAnalysisFlag">
                <div class="title mt-8">{{ $t('report.total_count') }}</div>
                <div v-if="vocabCounts[measure.type] == null" class="per per--none">-</div>
                <div v-else class="per per--counts"><span class="per-counts-big">{{vocabCounts[measure.type]}}</span>{{ $t('test_list.times') }}</div>
              </template>
              <template v-else>
                <div class="analysis-explanation mt-9">
                  <div class="icon" :class="[`icon--${measure.type}`]"></div>
                  <div class="text">{{ $t('report.pronunciation_count') }}</div>
                </div>
                <div class="analysis-explanation mt-3">
                  <div class="icon"></div>
                  <div class="text">
                    {{ $t('report.clear_count_prefix') }}{{measure.type == 'pa'?$t('test_list.patk_label_pa'):measure.type == 'ta'?$t('test_list.patk_label_ta'):$t('test_list.patk_label_ka')}}<span v-html="$t('report.clear_count_suffix')"></span>
                  </div>
                </div>
              </template>
            </div>
          </div>
          <div class="text-wrap" :class="!isAnalysisFlag?' mt-6':''">{{ $t('report.target_text_prefix') }}{{(measure.measurementType=='1' || (!measure.measurementType && measurementType=='1')) ? '30':'60'}}{{$t('report.target_text_suffix') }}</div>
          <div class="border-wrap" :class="!isAnalysisFlag? 'mt-11':'mt-5'"></div>
          <div class="bottom-wrap">
            <div class="bottom-wrap-inner" v-if="measure.type == 'pa'">
              <div class="mt-3">{{ $t('report.lip_motion') }}</div>
              <div class="bottom-wrap-text" :class="[`bottom-wrap-text--${measure.type}`]" v-html="$t('report.lip_motion_desc')">
              </div>
            </div>
            <div v-else-if="measure.type == 'ta'">
              <div class="mt-3">{{ $t('report.anterior_tongue_motion') }}</div>
              <div class="bottom-wrap-text" :class="[`bottom-wrap-text--${measure.type}`]" v-html="$t('report.anterior_tongue_motion_desc')">
              </div>
            </div>
            <div v-else-if="measure.type == 'ka'">
              <div class="mt-3">{{ $t('report.posterior_tongue_motion') }}</div>
              <div class="bottom-wrap-text" :class="[`bottom-wrap-text--${measure.type}`]" v-html="$t('report.posterior_tongue_motion_desc')">
              </div>
            </div>
            <div class="bottom-wrap-img" :class="[`bottom-wrap-img--${measure.type}`]"></div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- ボーダー -->
  <div class="report-border"></div>

  <!-- OF-5レポート -->
  <div class="report-of" :class="ofTotalFlag?'report-of--bad':''">
    <div class="report-of-detail flex justify-content-center">

      <div class="of-left">
        <div class="of-left-title">
        </div>
        <div class="of-left-border"></div>
        <div class="of-left-text mt-12">
          <span v-html="$t('oral_frailty_of5.explainer_prefix')"></span>
          <span class="of-left-text-highlight" v-html="$t('oral_frailty_of5.explainer_emphasis')"></span>
          <span v-html="$t('oral_frailty_of5.explainer_suffix')"></span>
        </div>
      </div>

      <div class="of-center">
        <div class="of-center-top" :class="ofResultFlag?'of-center-match':''">
          <div class="of-center-top-text">{{ $t('oral_frailty_result.left_title') }}</div>
          <div class="of-center-top-title">{{ofResultFlag?$t('oral_frailty_result.has_frailty'):$t('oral_frailty_result.no_frailty_report')}}</div>
          <div class="of-center-top-subtext mt-6">{{ $t('oral_frailty_of5.rule_a') }}</div>
        </div>
        <div class="of-center-bottom mt-4" :class="taResultFlag?'of-center-match':''">
          <div class="of-center-bottom-text" :class="!isAnalysisFlag ? 'of-center-bottom-text--gray':''">{{ $t('oral_frailty_of5.based_on_ta') }}</div>
          <div v-if="taResultScore == null" class="of-center-bottom-title of-center-bottom-title--gray">{{ $t('oral_frailty_of5.not_tested') }}</div>
          <div v-else class="of-center-bottom-title">{{taResultFlag ? $t('oral_frailty_result.has_frailty'):$t('oral_frailty_result.no_frailty_report')}}</div>
          <div class="of-center-bottom-subtext">{{ $t('oral_frailty_of5.rule_b') }}</div>
        </div>
      </div>

      <div class="of-right ml-10">
        <div class="of-right-check" v-for="(answer, index) in answers" :key="index">
          <input type="checkbox"
            :checked="answer === '1'"
            disabled
            class="of-checkbox">
          <div class="of-text" v-html="labels[index]"></div>
        </div>
        <div class="of-right-border"></div>
        <div class="of-right-check">
          <input type="checkbox"
            :checked="taResultScore < 6.0 && taResultScore != null"
            disabled
            class="of-checkbox"
            :class="taResultScore == null?'of-checkbox--none':''">
          <div class="of-text" :class="taResultScore == null ?'of-text--none':''" v-html="$t('oral_frailty_of5.item_5b')"></div>
        </div>
        <div class="of-right-source">{{ $t('oral_frailty_of5.reference') }}</div>
      </div>
    </div>
  </div>

  <!-- 下部情報 -->
  <div class="report-bottom">
    <div class="report-bottom-left">{{ inspectionTimeText }}  © 2025 Lion Corporation. All rights reserved.</div>
    <div class="report-bottom-center"></div>
    <div class="report-bottom-right"></div>
  </div>
</template>

<script>
import { buttom as pieButtom, center as pieCenter } from './common/pieChart';

export default {
  props: {
    isAnalysisFlag: { type: Boolean, default: false },
    measurements: { type: Array, default: () => [] },
    vocabPerSeconds: { type: Object, default: () => ({}) },
    vocabCounts: { type: Object, default: () => ({}) },
    analysisVocabCounts: { type: Object, default: () => ({}) },
    graphPercent: { type: Object, default: () => ({}) },
    measurementType: { type: String, default: null },
    ofResultFlag: { type: Boolean, default: false },
    ofTotalFlag: { type: Boolean, default: false },
    taResultFlag: { type: Boolean, default: false },
    taResultScore: { type: Number, default: null },
    answers: { type: Array, default: () => [] },
    labels: { type: Array, default: () => [] },
    inspectionTimeText: { type: String, default: '' },
  },
  setup(props) {
    const buttom = (measureWord) => pieButtom(props.graphPercent, measureWord);
    const center = (measureWord) => pieCenter(props.graphPercent, measureWord);

    return {
      buttom,
      center,
    };
  },
};
</script>

<style lang="scss" scoped>
@import '@/scss/style.scss';
</style>
